import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { STATUS } from 'src/app/shared/helpers/status';

@Pipe({
  name: 'getStatus'
})
export class StatusPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }

  transform(val: any | null): SafeHtml {
    if (!val) {
      return '';
    }

    // Normalize the value (case-insensitive comparison)
    const normalizedVal = val.toLowerCase();

    // Mapping statuses to display names (alphabetically sorted)
    const statusMapping: { [key: string]: string } = {
      [STATUS.ACCEPTED]: 'Accepted',
      [STATUS.ADDITIONAL]: 'Added',
      [STATUS.ACTIVE]: 'Active',
      [STATUS.ALL]: 'All',
      [STATUS.APPROVED]: 'Approved',
      [STATUS.APPROVAL_PENDING]: 'Approval Pending',
      [STATUS.AWAITING_FOR_APPROVAL]: 'Awaiting For Approval',
      [STATUS.CANCELLED]: 'Cancelled',
      ['CREATED']: 'Approval Pending',
      [STATUS.COMPLETED]: 'Completed',
      [STATUS.DRAFT]: 'Draft',
      [STATUS.FAILED]: 'Failed',
      [STATUS.INACTIVE]: 'Inactive',
      [STATUS.INVITED]: 'Invited',
      [STATUS.PENDING]: 'Pending',
      [STATUS.PENDING1]: 'PENDING1',
      [STATUS.PO_CREATED]: 'PO Created',
      [STATUS.PO_NOT_REQUIRED]: 'PO Not Required',
      [STATUS.PROCESSING]: 'Processing',
      [STATUS.PAYMENT_SUCCESS]: 'Payment Successful',
      ["PAYMENT_FAILED"]: 'Payment Failed',
      [STATUS.PAYMENT_IN_PROGRESS]: 'Payment In Progress',
      [STATUS.QUEUED]: 'Queued',
      [STATUS.RECEIVED]: 'Received',
      [STATUS.REVERSED]: 'Reversed',
      [STATUS.REJECTED]: 'Rejected',
      [STATUS.REJECTED1]: 'Rejected',
      [STATUS.REQUESTED]: 'Requested',
      [STATUS.SHORTLISTED]: 'Shortlisted',
      [STATUS.SENT]: 'Sent',
      [STATUS.SUCCESS]: 'Success',
      [STATUS.UNPAID]: 'Unpaid',
      [STATUS.UNKNOWN]: 'Under Process',
      ["no-answer"]: 'no-answer',
      ["Not Picked"]: 'Not Picked',
      ["Not interested"]: 'Not interested',
      ["Qualified"]: 'Qualified',
    };

    // Look for the corresponding key by normalizing to lowercase
    const statusKey = Object.keys(statusMapping).find(
      (key) => key.toLowerCase() === normalizedVal
    );
    // If no match is found, return the original value
    const displayText = statusKey ? statusMapping[statusKey] : val;
    // Define status-specific styles
    const styleMapping: { [key: string]: string } = {
      'Success': 'bg-green-300 text-green-700',
      'Paid': 'bg-green-300 text-green-700',
      'Payment Successful': 'bg-green-300 text-green-700',
      'Completed': 'bg-green-300 text-green-700',
      'Qualified': 'bg-green-300 text-green-700',
      'Accepted': 'bg-green-300 text-green-700',
      'Approved': 'bg-green-300 text-green-700',
      'Added': 'bg-green-300 text-green-700', // Positive status
      'Active': 'bg-primary-300 text-primary-700',
      'Invited': 'bg-primary-300 text-primary-700',
      'Sent': 'bg-primary-300 text-primary-700',
      'Requested': 'bg-primary-300 text-primary-700',
      'Shortlisted': 'bg-primary-300 text-primary-700',
      'Not interested': 'bg-primary-300 text-primary-700',
      'Reversed': 'bg-primary-300 text-primary-700',
      'Approval Pending': 'bg-primary-300 text-primary-700',
      'Awaiting For Approval': 'bg-primary-300 text-primary-700',
      'Unpaid': 'bg-red-300 text-red-700',
      'Failed': 'bg-red-300 text-red-700',
      'no-answer': 'bg-red-300 text-red-700',
      'Payment Failed': 'bg-red-300 text-red-700',
      'Rejected': 'bg-red-300 text-red-700',
      'Cancelled': 'bg-red-300 text-red-700', // Negative/Errored status
      'Not Picked': 'bg-red-300 text-red-700',
      'Processing': 'bg-orange-300 text-orange-700',
      'In Progress': 'bg-orange-300 text-orange-700',
      'Pending': 'bg-orange-300 text-orange-700',
      'Queued': 'bg-orange-300 text-orange-700',
      'PO Not Required': 'bg-gray-300 text-gray-700',
      'Draft': 'bg-gray-300 text-gray-700',
      'All': 'bg-gray-200 text-gray-600',
      'Rejected1': 'bg-gray-300 text-gray-700',
      'Unknown': 'bg-gray-300 text-gray-700',
    };

    // Get styles based on the status
    const styles = styleMapping[displayText] || 'bg-gray-200 text-gray-600';

    return this.sanitizer.bypassSecurityTrustHtml(
      `<div class='status-btn-card px-4 py-1 rounded ${styles} flex items-center justify-center mat-button'>${displayText}</div>`
    );
  }
}